function editOrderCustom(personalisationID) {
    $('.bootstrap-wrapper').show();
    var url = decodeURIComponent(pwCartPersonalisationUrls[personalisationID])
    opendialog(url);
}

$(document).ready(function() {
    $('.pw_category_block').addClass('pw_category_block_custom')
    $('.pw_breadcrumb').addClass('pw_breadcrumb_custom')


    $("#pw_cart_button").on("click", function(e) {
        $('.bootstrap-wrapper').show();
    });


    if ($("body.cart-template").length) {
        var enableEditOrders;
        data = {
            "func": "shopifyGetClientData"
        };
        $.ajax({
            type: 'POST',
            url: window.location.origin + "/a/greeting-cards/index.php",
            data: data,
            crossDomain: true,
            dataType: 'json',
            success: function(json_data, textStatus, jqXHR) {
                enableEditOrders = false;
                if (json_data.enableEditOrders == '1') {
                    enableEditOrders = true;
                }
                addEditOrderLinks(enableEditOrders);

            },
            error: function(json_data, textStatus, errorThrown) {
                console.log('pw: ERROR get clientID failed, card images will not be changed');
            }
        });

        var pwCartPersonalisationIDs = [];
        var textArray = $("form#cart td.cart-item__product .cart-item__options .flex:contains('PersonalisationID')");

        textArray.each(function() {

            var cardID = this.innerText.match(/PersonalisationID:.*/);
            cardID = cardID.input;
            cardID = cardID.match(/PersonalisationID:\s*(\S+)/)[1];

            var rand = Math.floor(Math.random() * 10000);
            var newSrc = "https://pwcdn.net/thumbnails/572/" + cardID + ".jpg?r=" + rand;
            $(this).parent().parent().parent().parent().parent().find("img").addClass("pwThumbImage");
            $(this).parent().parent().parent().parent().parent().find("img").attr("src", newSrc);
            $(this).parent().parent().parent().parent().parent().find("img").attr("srcset", newSrc);

            pwCartPersonalisationIDs.push(cardID);

        });

        function addEditOrderLinks(enableEditOrders) {
            if (enableEditOrders) {

                $.ajax({
                    type: 'POST',
                    url: window.location.origin + "/a/greeting-cards/index.php",
                    data: {
                        "func": "shopifyGetEditOrderLinks",
                        "pwEditOrderIDs": pwCartPersonalisationIDs
                    },
                    crossDomain: true,
                    dataType: 'json',
                    success: function(json_data, textStatus, jqXHR) {
                        pwCartPersonalisationUrls = json_data['editOrderUrls'];
                        for (var key in pwCartPersonalisationUrls) {
                            var matchingElement = null;

                            // First, try to find <dd> elements containing the personalisationID (for dl/dt/dd structures)
                            var ddElements = document.getElementsByTagName('dd');
                            for (var i = 0; i < ddElements.length; i++) {
                                var ddText = (ddElements[i].textContent || ddElements[i].innerText || '').replace(/\s+/g, ' ').trim();

                                // Check if this <dd> contains the personalisationID
                                if (ddText === key || ddText.indexOf(key) !== -1) {
                                    // Check if there's a sibling or parent-sibling <dt> with "PersonalisationID"
                                    var parent = ddElements[i].parentElement;
                                    if (parent) {
                                        var dtElements = parent.getElementsByTagName('dt');
                                        for (var j = 0; j < dtElements.length; j++) {
                                            var dtText = (dtElements[j].textContent || dtElements[j].innerText || '').trim();
                                            if (dtText.indexOf('PersonalisationID') !== -1) {
                                                matchingElement = ddElements[i];
                                                break;
                                            }
                                        }
                                        if (matchingElement) break;
                                    }
                                }
                            }

                            // If not found in dl/dt/dd structure, use TreeWalker approach
                            if (!matchingElement && document.createTreeWalker) {
                                var walker = document.createTreeWalker(
                                    document.body,
                                    NodeFilter.SHOW_TEXT,
                                    null,
                                    false
                                );

                                var node;
                                while (node = walker.nextNode()) {
                                    var text = node.textContent.trim();

                                    if (text.indexOf(key) !== -1 || text === key) {
                                        var parent = node.parentElement || node.parentNode;
                                        var parentText = parent.textContent.replace(/\s+/g, ' ').trim();

                                        if (parentText.indexOf('PersonalisationID') !== -1 && parentText.indexOf(key) !== -1) {
                                            matchingElement = parent;
                                            break;
                                        }
                                    }
                                }
                            }

                            if (!matchingElement) {
                                var allElements = document.getElementsByTagName('*');
                                for (var i = 0; i < allElements.length; i++) {
                                    var el = allElements[i];
                                    var text = el.textContent || el.innerText || '';
                                    text = text.replace(/\s+/g, ' ').trim();

                                    if ((text.indexOf('PersonalisationID') !== -1 && text.indexOf(key) !== -1) &&
                                        text.length < 500 &&
                                        el.tagName !== 'BODY' &&
                                        el.tagName !== 'HTML') {
                                        matchingElement = el;
                                        break;
                                    }
                                }
                            }

                            if (matchingElement) {
                                var alreadyProcessed = $(matchingElement).data('pw-processed') ||
                                    $(matchingElement).find('.pwEditOrderLink').length > 0;

                                if (alreadyProcessed) {
                                    continue;
                                }

                                var linkHtml;
                                linkHtml = ' <a href="javascript:void(0);" class="pwEditOrderLink" onClick="editOrderCustom(\'' + key + '\');">Edit</a>';


                                $(matchingElement).append(linkHtml);
                                $(matchingElement).data('pw-processed', true);
                            } else {
                                console.warn('PW cart item not found to add edit link:', key);
                            }
                        }
                    },
                    error: function(json_data, textStatus, errorThrown) {
                        console.log('pw: ERROR get pwEditOrderIDs failed, edit orders will not work');
                    }
                });
            }
        }


    }

    $("a.cart-drawer-button, .product-card__atc, .product-form__submit").on("click", function(e) {

        setTimeout(function() {
            var textArray = $("#CartDrawer ul li.cart-item .cart-item__options .flex:contains('PersonalisationID')");

            textArray.each(function() {

                var cardID = this.innerText.match(/PersonalisationID:.*/);
                cardID = cardID.input;
                cardID = cardID.match(/PersonalisationID:\s*(\S+)/)[1];

                var rand = Math.floor(Math.random() * 10000);
                var newSrc = "https://pwcdn.net/thumbnails/572/" + cardID + ".jpg?r=" + rand;
                $(this).parent().parent().parent().parent().parent().find("img").addClass("pwThumbImage");
                $(this).parent().parent().parent().parent().parent().find("img").attr("src", newSrc);
                $(this).parent().parent().parent().parent().parent().find("img").attr("srcset", newSrc);



            });
        }, 2500);
    });




});